import script from "./MenuBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./MenuBanner.vue?vue&type=script&setup=true&lang=ts"

import "./MenuBanner.vue?vue&type=style&index=0&id=d42163d0&lang=scss"

const __exports__ = script;

export default __exports__